export default {
  listTitle: 'Componentes',
  resizePanel: 'Cambiar el tamaño del panel de componentes',
  maximizePanel: 'Maximizar panel de componentes',
  minimizePanel: 'Restaurar tamaño del panel de componentes',
};
